import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
    declare refreshAfterValue: number
    declare hasRefreshAfterValue: boolean
    declare refreshUrlValue: string

    static values = {
        refreshAfter: Number,
        refreshUrl: String,
    }

    headers = { Accept: 'text/vnd.turbo-stream.html' }

    connect() {
        // If something breaks and cannot get the value from the server we do not want to go into an infinite loop
        if (!this.hasRefreshAfterValue) {
            this.refreshAfterValue = 60000
        }
        setTimeout(() => this.fetchData(), this.refreshAfterValue)
    }

    fetchData() {
        fetch(this.refreshUrlValue, {
            headers: this.headers,
        })
            .then((value) => value.text())
            .then((turboStreamsMsg) => {
                // Render Turbo Streams to DOM
                // @ts-ignore ; using global Turbo here to avoid re-importing
                Turbo.renderStreamMessage(turboStreamsMsg)
            })
    }
}
